import { createContext, useContext, useState } from 'react';

const EquipmentContext = createContext();

export function EquipmentContextProvider({ children }) {

  const [equipment, setEquipment] = useState({});

  const [equipmentList, setEquipmentList] = useState([]); 
  
  const [typedEquipment, setTypedEquipment] = useState("");

  return(
    <EquipmentContext.Provider 
      value={{
        equipment,
        setEquipment,
        equipmentList,
        setEquipmentList,
        typedEquipment,
        setTypedEquipment,
      }}
    >
      {children}
    </EquipmentContext.Provider>
  ); 
}

export const useEquipment = () => {
  return useContext(EquipmentContext);
}